/* eslint-disable max-lines-per-function */
import { useCallback } from 'react';

import { Modal, ModalWidth } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';
import { GenerateStatisticsForm } from '../forms/GenerateStatisticsForm';
import { GenerateStatisticsModalConfirmButtonSwitch } from '../forms/GenerateStatisticsModalConfirmButtonSwitch';

import { CommonStatisticsCode } from './StatisticsListTable.types';
import { handleStatisticsRefetch } from './GenerateStatisticsModal.utils';
import { GenerateStatisticsModalButtons } from './GenerateStatisticsModalButtons';

type GenerateStatisticsModalProps = {
   readonly code: CommonStatisticsCode;
   readonly closeModal: VoidFunction;
};

export const GenerateStatisticsModal = (props: GenerateStatisticsModalProps): JSX.Element => {
   const { code } = props;

   const handleOnSuccess = useCallback(() => {
      handleStatisticsRefetch(props.closeModal);
   }, [props.closeModal]);

   return (
      <Modal
         title={statisticsTranslationKeys.modal.title}
         onCloseRequest={props.closeModal}
         animateVisibility
         width={ModalWidth.NORMAL}
         testId={'generateStatisticsModal'}
         visible
      >
         <GenerateStatisticsForm code={code}>
            {({ handleSubmit, formState }) => (
               <>
                  <GenerateStatisticsModalConfirmButtonSwitch
                     code={code}
                     handleSubmit={handleSubmit}
                     onSuccess={handleOnSuccess}
                  />
                  <GenerateStatisticsModalButtons
                     handleClose={props.closeModal}
                     shouldConfirmExit={formState.isDirty}
                  />
               </>
            )}
         </GenerateStatisticsForm>
      </Modal>
   );
};
